<template>
	<div class="row d-flex justify-content-center align-items-center text">
        <div class="col-12 text-center">
          	<span class="font-weight-bold">{{ data.nev }}</span>
          	<span class="h5" v-show="data.cegnev != ''">({{ data.cegnev }})</span>
          	<span class="h5" v-show="data.cegnev === ''">(Magánszemély)</span>
          	<span>Teljes megrendelés története</span>                  
        </div>
        <div class="col-12">
        	<div class="row">
                <div class="col-12 col-lg-8">
                  	<div class="row">
                    	<div class="col-12">
                      		<div class="row">
                        		<div class="col-2">#</div>
                        		<div class="col-2" v-for="n in cyc_count">
                          			{{ parseInt(date) + parseInt(n - 1) }}
                        		</div>
                      		</div>
                    	</div>
                	</div>
	              	<div class="row">
	                	<div class="col-12">
	                  		<div class="row" v-for="n in 12">
		                    	<div class="col-2">
		                      		{{ honapok[n-1].honap }}
		                    	</div>
		                    	<div
		                    		class="col-2"
		                    		v-for="m in cyc_count"
		                    		:class="[get_befiz(date,m,honapok[n-1].value,data.datum) < data.min && get_befiz(date,m,honapok[n-1].value,data.datum) != '' ? 'text-danger font-weight-bold' : '']"
		                    	>
		                      		{{ get_befiz(date,m,honapok[n-1].value,data.datum) | huf }} Ft
		                    	</div>
		                  	</div>
	                  		<hr>
		                  	<div class="row">
		                    	<div class="col-2">Összesen</div>
		                    	<div class="col-2" v-for="n in cyc_count">
		                      		<div v-show="sum(date,n,data.list_ev) >= 0">
		                        		{{ sum(date,n,data.list_ev) | huf }} Ft
		                      		</div>
		                    	</div>
		                  	</div>
	                  		<div class="row">
		                    	<div class="col-2">Átlag 12</div>
		                    	<div class="col-2" v-for="n in cyc_count" >
		                      		<div v-show="sum(date,n,data.list_ev) >= 0">
		                        		{{ Math.floor(sum(date,n,data.list_ev) / 12) | huf }} Ft
		                      		</div>
		                    	</div>
		                  	</div>
	                  		<div class="row">
	                    		<div class="col-2">Átlag aktív</div>
	                    		<div class="col-2" v-for="n in cyc_count">
	                      			<div
	                      				v-show="sum_aktiv(date,n,data.list_aktiv_ev,data.datum) > 0"
	                      				:class="[Math.floor(sum(date,n,data.list_ev)) / sum_aktiv(date,n,data.list_aktiv_ev,data.datum) < data.min ? 'text-danger font-weight-bold' : '']"
	                      			>
	                        			{{ Math.floor(Math.floor(sum(date,n,data.list_ev)) / sum_aktiv(date,n,data.list_aktiv_ev,data.datum)) | huf }} Ft
	                      			</div>
	                    		</div>
	                  		</div>
	                  		<div class="row">
	                    		<div class="col-2">Vállalt</div>
	                    		<div class="col-2" v-for="n in cyc_count">
	                      			{{ data.min | huf }} Ft
	                    		</div>
	                  		</div>
	                	</div>
	              	</div>  
	            </div>
                <div class="col-12 col-lg-4">
                  	<div class="row mt-1 text-center">
                    	<div class="col-12 h5">
                      		Értékelés
                    	</div>
                  	</div>
	                <div class="row border-top border-left border-right">
	                   	<div class="col-8 text-left">
	                      	Ügyfél szerződés kezdete: 
	                    </div>
	                    <div class="col-4 text-left">
	                      	{{ data.datum.substring(0,10) }}
	                    </div>
                  	</div>
                  	<div class="row border-top border-left border-right">
	                    <div class="col-8 text-left">
	                     	Az elmúlt 12 hónapban élő szerződéses hónapok száma:
	                    </div>
	                    <div class="col-4 text-left">
	                      	{{ data.aktiv_h }}
	                    </div>
                  	</div>
                  	<div class="row border-top border-left border-right">
	                    <div class="col-8 text-left">
	                      	Az elmúlt 12 hónap teljes rendelési összege:
	                    </div>
	                    <div class="col-4 text-left">
	                      	{{ data.aktiv_osszeg | huf }} Ft
	                    </div>
                  	</div>
                  	<div class="row border-top border-left border-right">
	                    <div class="col-8 text-left">
	                      	Élő szerződéssel rendelkező hónapokra vetített havi átlaga (max 12 hónap):
	                    </div>
	                    <div class="col-4 text-left">
	                      	{{ data.aktiv_atlag | huf }} Ft
	                    </div>
	                </div>
                  	<div class="row border-top border-left border-right">
                    	<div class="col-8 text-left">
                      		Szerződött rendelési minimum korlát:
                    	</div>
                    	<div class="col-4 text-left">
                      		{{ data.min | huf }} Ft
                    	</div>
                  	</div>
                  	<div class="row border-top border-left border-right">
                    	<div class="col-8 text-left">
                      		Teljesítettség százalékban:
                    	</div>
                    	<div class="col-4 text-left">
                      		{{ data.aktiv_sz }}%
                    	</div>
                  	</div>
                  	<div class="row border" v-show="data.aktiv_sz < 90">
                    	<div class="col-8 text-left">
                      		Értékelés a jelenlegi állapotnak megfelelő utolsó 12 hónapról:
                    	</div>
                    	<div class="col-4 text-left text-danger">
                      		<strong>ALULTELJESÍT</strong>
                    	</div>
                  	</div>
                  	<div class="row border" v-show="data.aktiv_sz >= 90">
                    	<div class="col-8 text-left">
                      		Értékelés a jelenlegi állapotnak megfelelő utolsó 12 hónapról:
                    	</div>
                    	<div class="col-4 text-left text-success">
                      		<strong>RENDBEN</strong>
                    	</div>
                  	</div>
                  	<div class="row mt-1 text-center">
                    	<div class="col-12 h5">
                      		Adatok
                    	</div>
                  	</div>
                  	<div class="row border-top border-left border-right">
                    	<div class="col-6">
                          	Automata
                          	<input type="checkbox" disabled :checked="data.automataa == '1'">
                        </div>
                        <div class="col-6">
                          	Szerződés
                          	<input type="checkbox" disabled :checked="data.automata_szerzodes == '1'">
                        </div>
                  	</div>
                  	<div class="row border-top border-left border-right">
                    	<div class="col-4 text-left">
                      		Kategória
                    	</div>
                    	<div class="col-8 text-left">
                      		{{data.kat}}
                    	</div>
                  	</div>
                  	<div class="row border-top border-left border-right">
                    	<div class="col-2 text-left">
                      		Cím
                    	</div>
                    	<div class="col-10 text-left">
                      		{{data.varos}} - {{data.cim}}
                    	</div>
                  	</div>
                  	<div class="row border-top border-left border-right">
                    	<div class="col-4 text-left">
                      		Dátum limit
                    	</div>
                    	<div class="col-8 text-left" v-show="data.datum_limit != ''">
                      		{{data.datum_limit}} nap
                    	</div>
                    	<div class="col-8 bg-warning" v-show="data.datum_limit == ''">
                      		Nincs beállítva dátum limit
                    	</div>
                  	</div>
                  	<div class="row border-top border-left border-right">
                    	<div class="col-4 text-left">
                      		Telefon 1
                    	</div>
                    	<div class="col-8 text-left" v-show="data.telv != ''">
                      		{{data.telv | tel }}
                    	</div>
                    	<div class="col-8 bg-warning" v-show="data.telv == ''">
                      		Nincs telefonszám
                    	</div>
                  	</div>
                  	<div class="row border-top border-left border-right">
                    	<div class="col-4 text-left">
                      		Telefon 2
                    	</div>
                    	<div class="col-8 text-left" v-show="data.telm != ''">
                      		{{data.telm | tel }}
                    	</div>
                    	<div class="col-8 bg-warning" v-show="data.telm == ''">
                      		Nincs telefonszám
                    	</div>
                  	</div>
                  	<div class="row border">
                    	<div class="col-4 text-left">
                      		E-mail cím
                    	</div>
                    	<div class="col-8 text-left" v-show="data.email != ''">
                      		{{data.email}}
                    	</div>
                    	<div class="col-8 bg-warning" v-show="data.email == ''">
                      		Nincs e-mail cím
                    	</div>
                  	</div>
                </div>
            </div>
        </div>
		<div class="col-12 text-center">
			<div class="row d-flex justify-content-center align-items-center">
	            <div class="col-10 text-center h5">
	                Megjegyzés
	            </div>
	            <div class="col-10 border">
	                <div class="text-center m-2">
	                    {{data.megj}}
	                </div>
	            </div>
	        </div>
		</div>
	    <div class="col-12 text-center">
	        <button
	          	class="btn btn-outline-primary m-1"
	          	@click.prevent="neworder(data.id)"
	        >
	          	Új rendelés indítása
	        </button>
	        <router-link
              :to="`/customer/${data.id}`" target="_blank"
          >
              <button class="btn btn-outline-primary m-1">
                  Ügyfél módosítás
              </button>
          </router-link>
          <order-history
              class="m-1"
              :id="data.uszam"
          >
          </order-history>
	    </div>   
		<div class="col-12">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-10">
					<div class="divider text-center"></div>
				</div>
			</div>
		</div>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
export default {
	name: `gorditem`,

	props: ['data', 'date'],

	data() {
		return {
			cyc_count: 5,
			list: []
		}
	},

	created(){
		this.list = JSON.parse(this.data.list)
		this.list_ev = JSON.parse(this.data.list_ev)
		this.list_aktiv_ev = JSON.parse(this.data.list_aktiv_ev)
	},

	methods: {
		...mapActions(['setrendselcustomer']),

		neworder(id){
			var item = {}
			this.$Progress.start()
          	this.isLoading = true
          	this.req.post(`/customers/search`,{
              	search: {id: id},
              	order: `nev`,
              	order_dir: false
          	})
              	.then(res => {
                  	item = res.data.customers[0]
                  	this.setrendselcustomer(item)
          			window.open(this.$router.resolve({ path: '/orders/new_order/products' }).href, '_blank')
                  	this.$Progress.finish()
                  	this.isLoading = false
              	})
              	.catch(err => {
                	console.log(err)
                	this.$Progress.fail()
                	this.isLoading = false
             	})
      	},

		get_befiz(year,m,honap,miota) {
      		var osszeg = ''
      		var keres_d = `${parseInt(year)+parseInt(m-1)}-${honap}`
      		var akt = this.$moment(keres_d)
      		var miota = this.$moment(`${miota.substring(0,7)}`)
		    if (akt > miota) { osszeg = 0 }
		    if (this.list != null) {
		    	var item = this.list.find(x => x.datum === keres_d)
		        osszeg = item != undefined ? item.osszeg : ''
		    }
		    return osszeg
	    },

	    sum(date,n) {
      		var datum = ~~date+n-1
      		var item = this.list_ev.find(x => x.datum === datum.toString())
      		return item !== undefined ? item.osszeg : 0
    	},

    	sum_aktiv(year,n,miota) {
	      var aktiv = 0
	      var has = false
	      this.honapok.map(h => {
	        	var keres_d = `${parseInt(year)+parseInt(n-1)}`
	        	var akt = this.$moment(`${keres_d}-${h.value}-01`)
	        	var datum = this.$moment(`${miota.substring(0,7)}-01`)
	        	if (this.list_aktiv_ev != null) {
	        		has = this.list_aktiv_ev.find(x => x.datum === `${keres_d}-${h.value}`)
	        	}
	        	if (has != undefined) { 
	          		aktiv++
	        	} else if (akt > datum) {
	          		aktiv++
	        	}
	      })
	      return aktiv
    	},

    	min(osszeg) {
      		return osszeg === '' ? 'ADATHIÁNY' : osszeg
    	}

	}
}	
</script>
<style scoped>
.divider {
  	border: 1px solid black;
  	margin-bottom: 15px;
}

.text {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/stats/gordulo_item.vue